// Canal de uma conexão / de um contato, do lado do front.
//
// Espelha backend/dist/helpers/CanalConexao.js. O front recebe dois campos distintos e
// não intercambiáveis: `whatsapp.tipo` (o canal da CONEXÃO) e `contact.canal` (de onde
// veio o CONTATO, que só existe para Messenger e Instagram — nulo é WhatsApp).

export const TIPO_BAILEYS = "whatsapp_baileys";
export const TIPO_WHATSAPP_OFICIAL = "whatsapp_oficial";
export const TIPO_MESSENGER = "messenger";
export const TIPO_INSTAGRAM = "instagram";

const MENSAGERIA = [TIPO_MESSENGER, TIPO_INSTAGRAM];

/**
 * Conexão sem os recursos do Baileys: não dá para editar, apagar nem encaminhar mídia,
 * e não há sessão para desconectar.
 *
 * Lê `oficial` E `tipo` de propósito. `oficial` sozinho não basta — nas conexões de
 * Messenger e Instagram a coluna é `false`, e o menu ofereceria as três ações para
 * depois o backend recusar cada uma na cara do atendente.
 */
export const ehCanalRestrito = (whatsapp) =>
  !!(whatsapp && (whatsapp.oficial || MENSAGERIA.includes(whatsapp.tipo)));

export const ehMensageriaMeta = (tipo) => MENSAGERIA.includes(tipo);

export const rotuloCanal = (tipo) => {
  switch (tipo) {
    case TIPO_MESSENGER: return "Messenger";
    case TIPO_INSTAGRAM: return "Instagram";
    case TIPO_WHATSAPP_OFICIAL: return "WhatsApp oficial";
    default: return "WhatsApp";
  }
};
